import React, { useRef, useEffect } from 'react';
import './Hero.css';import bgVideo from '../../assets/Bgvideo8sCom.mp4';


const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ensure video plays on mobile devices
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log('Video autoplay failed:', error);
      });
    }
  }, []);

  return (
    <div className="hero" id="hero">
      <video 
        ref={videoRef}
        className="hero__video" 
        autoPlay 
        loop 
        muted 
        playsInline
        preload="auto"
      >
        <source src={bgVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <h1 className="hero__title">
        We unite people and technology to build a better future.
      </h1>
    </div>
  );
};

export default Hero;